'use client';

import React, { useState, useEffect } from 'react';
import { TemplateManager, TemplateFormData, TestEmailData } from '@contentgrowth/content-emailing/frontend';
import { useEmailService } from '@/app/admin-tools/api/email';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'react-hot-toast';

export default function EmailTemplatesPage() {
    const emailService = useEmailService();
    const { user } = useAuth();
    const [settings, setSettings] = useState<any>({});

    useEffect(() => {
        emailService.getSettings().then(setSettings).catch(e => console.error('Failed to load settings', e));
    }, []);

    const handleLoadTemplates = async () => {
        return await emailService.getAllTemplates();
    };

    const handleSaveTemplate = async (data: TemplateFormData) => {
        try {
            await emailService.saveTemplate(data as any);
            toast.success('Template saved successfully');
        } catch (error: any) {
            console.error('Failed to save template:', error);
            const msg = error?.response?.data?.error || error.message || 'Failed to save template';
            toast.error(msg);
            throw error;
        }
    };

    const handleDeleteTemplate = async (id: string) => {
        // Implement delete in API if not exists, but for now assuming it might needed
        // Check API client: it doesn't have deleteTemplate.
        // Let's add it or skip for now.
        // The library TemplateManager supports it optionally.
        // Let's check api/email.ts again.
        // It does NOT have deleteTemplate.
        // I will implement a stub or add it to API client first.
    };

    const handleSendTestEmail = async (data: TestEmailData) => {
        try {
            await emailService.sendTestEmail({
                template_id: data.template_id,
                to: data.to,
                variables: typeof data.variables === 'string' ? JSON.parse(data.variables || '{}') : data.variables
            });
            toast.success('Test email sent');
        } catch (error: any) {
            console.error('Failed to send test email:', error);
            const msg = error?.response?.data?.error || error.message || 'Failed to send test email';
            toast.error(msg);
            throw error;
        }
    };

    return (
        <div className="py-6">
            <TemplateManager
                onLoadTemplates={handleLoadTemplates}
                onSaveTemplate={handleSaveTemplate}
                onSendTestEmail={handleSendTestEmail}
                // onDeleteTemplate={handleDeleteTemplate} // Enable after adding API support
                title="Email Templates"
                description="Manage and edit system email templates."
                defaultTestValues={{
                    to: user?.email || '',
                    variables: {
                        brandName: settings.brandName || 'Content Growth',
                        name: user?.displayName || user?.email?.split('@')[0] || 'Admin',
                        email: user?.email || '',
                        url: typeof window !== 'undefined' ? window.location.origin : 'https://app.content-growth.com'
                    }
                }}
            />
        </div>
    );
}
